import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { withStyles } from '@material-ui/styles';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import styles from '../../../style';

import {
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { getLocations } from 'services/util/action';
import { connect } from 'react-redux';
import {
  getCaseFiles,
  getPatientDocuments,
  getRecaps,
} from 'services/home/action';

import moment from 'moment';

const TableRowsLoader = ({ rowsNum = 10 }) => ( 
    <TableBody style={{ width: '100%' }}>
      {[...Array(rowsNum)].map((_, index) => (
        <TableRow key={index}>
          <TableCell>
            <Skeleton animation="wave" variant="text" />
          </TableCell>
          <TableCell>
            <Skeleton animation="wave" variant="text" />
          </TableCell>
        </TableRow>
      ))}
    </TableBody> 
);

const Details = props => {
  const {
    classes,
    className,
    locations,
    ehrID,
    profile,
    userID,
    clinicalDocuments,
    loading,
    ...rest
  } = props;

  const [data, setData] = useState([]);
  const [dataHx, setDataHX] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (clinicalDocuments && clinicalDocuments.length > 0) {
      let datatopush = [];
      clinicalDocuments.forEach(function (item) {
        if (item.isActive) {
          datatopush.push({
            patientId: item.documentRoute.patientid,
            patientDocumentId: item.documentRoute.patientDocumentId,
            routeTo: item.documentRoute.routeTo,
            patient: item.patient,
            title: item.documentRoute.description,
            documentCreated: item.documentCreated
              ? moment(item.documentCreated).format('MM/DD/YYYY')
              : ''
          });
        }
      });
      setData(datatopush);
    }
  }, [clinicalDocuments]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const theme = createTheme({
    overrides: {
      MuiButton: {
        containedSizeSmall: {
          backgroundColor: '#03A484',
          color: 'white',
          fontSize: 10,
          boxShadow: 'none',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: '#13b998',
            boxShadow: 'none'
          }
        }
      },
      MUIDataTable: {
        responsiveScroll: {
          maxHeight: 'none'
        }
      },
      MuiTableCell: {
        root: {
          padding: '10px 10px',
          fontSize: 12
        }
      },
      MuiToolbar: {
        root: {
          minHeight: '48px!important'
        }
      },
      MUIDataTableHeadRow: {
        root: {
          backgroundColor: '#EFF5FC!important'
        }
      },
      MUIDataTableHeadCell: {
        toolButton: {
          fontSize: 12
        },
        fixedHeader: {
          backgroundColor: 'transparent!important',
          height: 45,
          borderTop: '1px solid #D4E5F9',
          borderBottom: '1px solid #D4E5F9'
        }
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: 'transparent!important',
          height: 45,
          borderTop: '1px solid #D4E5F9',
          borderBottom: '1px solid #D4E5F9'
        }
      },
      MUIDataTableToolbar: {
        icon: {
          transform: 'scale(.8)'
        },
        titleText: {
          fontSize: '16px!important',
          fontWeight: '600!important',
          fontFamily: 'Lato!important'
        }
      },
      MUIDataTableToolbarSelect: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'rgba(255,0,0,.2)',
          boxShadow: 'none',
          borderRadius: '0px!important'
        }
      },
      MuiTableRow: {
        root: { '&$hover:hover': { backgroundColor: '#EFF5FC' } }
      },
      MuiTablePagination: {
        caption: {
          fontSize: 12
        }
      },
      MuiOutlinedInput: {
        inputSelect: {
          padding: 0,
          padding: '5px 10px',
          fontSize: 12,
          height: 18,
          borderColor: 'red'
        }
      },
      MuiTableSortLabel: {
        icon: {
          height: 16,
          width: 16,
          color: '#5698d5!important'
        }
      }
    }
  });

  const columns = [
    {
      name: 'patientId',
      options: { display: 'excluded' }
    },
    {
      name: 'patientDocumentId',
      options: { display: 'excluded' }
    },
    {
      name: 'routeTo',
      options: { display: 'excluded' }
    },
    {
      name: 'dob',
      options: { display: 'excluded' }
    },
    {
      name: 'patient',
      options: { display: 'excluded' }
    },
    {
      name: 'title',
      label: 'Description',
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <span
            style={{ cursor: 'pointer' }}
            onClick={() =>
              props.handleOpenDoc(
                tableMeta.rowData[0],
                tableMeta.rowData[1],
                tableMeta.rowData[2],
                tableMeta.rowData[3],
                tableMeta.rowData[4],
                tableMeta.rowData[5],
                tableMeta.rowData[6]
              )
            }>
            {value}
          </span>
        )
      }
    },
    {
      name: 'documentCreated',
      label: 'Created On',
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <span
            style={{ cursor: 'pointer' }}
            onClick={() =>
              props.handleOpenDoc(
                tableMeta.rowData[0],
                tableMeta.rowData[1],
                tableMeta.rowData[2],
                tableMeta.rowData[3],
                tableMeta.rowData[4],
                tableMeta.rowData[5],
                tableMeta.rowData[6]
              )
            }>
            {value}
          </span>
        )
      }
    }
  ];

  const options = {
    filter: false,
    responsive: 'scroll',
    elevation: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    search: false,
    viewColumns: false,
    selectableRows: false,
    serverSide: true,
    onRowClick: rowData =>
      props.handleOpenDoc(
        rowData[0],
        rowData[1],
        rowData[2],
        rowData[3],
        rowData[4],
        rowData[5],
        rowData[6]
      )
  };

  const BodyComponent = React.useMemo(
    () => (props) => <LoadingTableBody loading={loading} {...props} />,
    [loading]
  );

  const LoadingTableBody = ({ loading, ...props }) => {
    const { options, columns, ...others } = props;

    if (loading) {
      // Only replace the rows, keep header/toolbar from MUIDataTable
      return <TableRowsLoader rowsNum={10} colsNum={2} />;
    }

    // Fallback to original internal body
    const DefaultBody = require('mui-datatables').TableBody; // v3/v4 internal export

    return <DefaultBody options={options} columns={columns} {...others} />;
  };

  return (
    <Card {...rest} className={clsx(classes.subTabRoot, className)}>
      <Grid container>
        <Grid className={classes.cardHeader} item xs={8}>
          <Typography variant="h2">
            {(profile && profile.firstname ? profile.firstname : '') +
              ' ' +
              (profile && profile.lastname ? profile.lastname : ' ') +
              ' '}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <CardContent> 
          <MuiThemeProvider theme={theme}>
            <div className={classes.fullWidthTable}>
              <MUIDataTable
                columns={columns}
                data={data}
                options={options} 
                components={{
                  TableBody: BodyComponent,
                }}
              />
            </div>
          </MuiThemeProvider>  
      </CardContent>
    </Card>
  );
};

Details.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = {
  getLocations,
  getCaseFiles,
  getPatientDocuments,
  getRecaps,
};

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  userID: state.profile && state.profile.userID,
  profile: state && state.profile,
  casefiles: state.home && state.home.list,
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(withStyles(styles)(Details));